import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { IApplicationState } from '../../types/redux';
import { selectCurrentPageMeta } from '../../selectors/pagesMeta';
import { selectCurrentListingMeta } from '../../selectors/listings';

/**
 * Слушает мету и высчитывает общее количество страниц
 */
export const useCurrentListingTotalPages = () => {
  const { pathname } = useLocation();
  const { type: pageType } = useSelector((state: IApplicationState) => selectCurrentPageMeta(state, pathname));
  const { total: totalPosts, limit } = useSelector((state: IApplicationState) =>
    selectCurrentListingMeta(state, pageType),
  );
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    if (!totalPosts || !limit) {
      setTotalPages(0);

      return;
    }

    setTotalPages(Math.ceil(totalPosts / limit));
  }, [limit, totalPosts]);

  return totalPages;
};
